import { type FilterParams } from '@/components/user/hooks/useUserFilter'
import apiService from '@/service/api.service'
import { useSWR } from '@attensi/swr'
import { computed, ref, type Ref } from 'vue'

type FilterParamKey = keyof FilterParams

type ParamFilterArray = [FilterParamKey, string | number | boolean | null][]

const searchUsers = (params: ParamFilterArray) => {
  const paramsObject = Object.fromEntries(params) as FilterParams
  return apiService.getUsersSearch(paramsObject)
}

export const useUsers = (filterParams: Ref<FilterParams>) => {
  const paramsArray = computed(
    () => Object.entries(filterParams.value) as ParamFilterArray
  )

  const { data, error } = useSWR([paramsArray, 'get-users'], searchUsers)

  const prevUsers = ref([])

  const users = computed(() => {
    const users = data.value?.data.data
    if (users) {
      prevUsers.value = JSON.parse(JSON.stringify(users))
    }
    return prevUsers.value
  })

  const prevPagination = ref({
    current: 1,
    previous: null,
    next: 2,
    per_page: 25,
    pages: 1,
    count: 0,
  })

  const pagination = computed(() => {
    const pagination = data.value?.data.pagination
    if (pagination) {
      prevPagination.value = pagination
    }
    return prevPagination.value
  })

  const loading = computed(
    () => data.value === undefined && error.value === undefined
  )

  const usersCount = computed(() => pagination.value.count)

  return { users, pagination, loading, usersCount }
}
